import React from "react";
import { StyledButtons } from "./styled";
import MapButton from "../MapButton";
import { initialBounds } from "../../config";

function MapButtons({
  className,
  mapRef,
  onReset,
  showStates = false,
  showReset = false,
  ...props
}) {
  const handleUSAClick = () => {
    mapRef.current.fitBounds(initialBounds, { zoom: 3 });
  };

  const handleHawaiiClick = () => {
    mapRef.current.fitBounds([
      [-161.4111328125, 17.156537255486093],
      [-152.3583984375, 23.498514375479786],
    ]);
  };

  const handleAlaskaClick = () => {
    mapRef.current.fitBounds([
      [-173.056640625, 50.31039245071915],
      [-128.583984375, 72.24556692540702],
    ]);
  };

  const handleReset = () => {
    onReset();
  };

  return (
    <StyledButtons className={className}>
      {showStates && (
        <>
          <MapButton label="Hawaii" onClick={handleHawaiiClick}>
            <img src="/hawaii.svg" alt="" />
          </MapButton>
          <MapButton label="Alaska" onClick={handleAlaskaClick}>
            <img src="/alaska.svg" alt="" />
          </MapButton>
          <MapButton label="USA" onClick={handleUSAClick}>
            <img src="/usa.svg" alt="" />
          </MapButton>
        </>
      )}
      {showReset && (
        <MapButton label="Reset" onClick={handleReset}>
          <img src="/center.svg" alt="" />
        </MapButton>
      )}
    </StyledButtons>
  );
}

export default MapButtons;
